import React from "react"
import propTypes from "prop-types"
import Fade from "react-reveal/Fade"
import styled from "styled-components"

import Link from "../../utils/link"

import "./Product.scss"

const Product = ({ product, addVariantToCart }) => {
  const ProductImageElement = styled.div`
    background-image: url(${product.images[0].originalSrc ||
    product.images[0].src});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center bottom;
  `

  const ProductElement = styled.div`
    &:hover {
      .product__link__image {
        background-image: url(${product.images[1].originalSrc || product.images[1].src});
        background-size: cover;
        background-position: center bottom;
      }
    }
  `

  return (
    <Fade>
      <ProductElement className="product">
        <Link to={`/shop/${product.handle}`} className="product__link">
          <ProductImageElement className="product__link__image" />

          <h4 className="product__link__title">
            {product.title} &#8212; &#36;
            {parseFloat(product.priceRange?.minVariantPrice.amount).toFixed(2)}
          </h4>
        </Link>


        { addVariantToCart &&
          <button
            className="product__cart-button"
            onClick={() => {
              addVariantToCart(product.variants[0].storefrontId, 1)
            }}
          >
            Add to Cart
          </button>
        }
      </ProductElement>
    </Fade>
  )
}

Product.propTypes = {
  product: propTypes.object.isRequired,
  addVariantToCart: propTypes.func,
}

export default Product
